import React from 'react';
import { render } from 'react-dom';
import thunkMiddleware from 'redux-thunk';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import allReducers from 'reducers';
import App from 'containers/App/App';
import 'global/css/reset.scss';

const store = createStore(
	allReducers,
	applyMiddleware(thunkMiddleware)
);
 
// Render the React app into the main application div in the index.html file
render((
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
), document.getElementById('main-application'));




// WEBPACK FOOTER //
// ./index.js